export default "__VITE_ASSET__Bsi2UKou__"